import { type QuoteAnswer, type QuoteOffer, type QuoteRejection, QuoteStatus } from 'screens/QuoteDetails/QuoteDetails.types'

export const isQuoteOfferAnswer = (answer: QuoteAnswer): answer is QuoteOffer =>
  answer.status === QuoteStatus.SUBMITTED

export const isQuoteRejectionAnswer = (answer: QuoteAnswer): answer is QuoteRejection =>
  answer.status === QuoteStatus.REJECTED
